import React from 'react'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControl from '@material-ui/core/FormControl'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { ClassValue } from 'classnames/types'
import { useMediaQuery } from 'react-responsive'
import classNames from 'classnames'
import { Field, FieldRenderProps } from 'react-final-form'
import { fieldModel } from '../../types/fields/fieldsModel'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormRadioField from './FormRadioField'

const useStyles = makeStyles(
	(theme) => (
		{
			...styles(theme),
			formControl: {
				width: '100%'
			},
			radioGroupRow: {
				flexDirection: 'row'
			},
			radioGroupColumn: {
				flexDirection: 'column'
			},
			smallGroup: {
				justifyContent: 'space-between'
			},
			largeGroup: {
				'& label:not(:first-child)': {
					marginLeft: 150
				}
			},
			errorStyle: {
				color: '#B92D00',
				fontSize: '10px'
			}
		}
	)
)

interface AcceptingProps {
	items: fieldModel[],
	textStyle: string,
	textColor: string,
	textWeight?: string,
	margin: boolean,
	rowDirection: boolean,
	spaceBetween?: boolean,
}

type RadioFieldProps = AcceptingProps & FieldRenderProps<string>

const FormRadioGroup: React.FC<RadioFieldProps> = (
	{
		meta: {
			touched,
			error
		},
		input,
		items,
		textStyle,
		textColor,
		textWeight,
		margin,
		rowDirection,
		spaceBetween = true,
	}
) => {
	const classes = useStyles()
	const isMobileScreen = useMediaQuery(
		{
			query: '(max-width: 500px)'
		}
	)
	const radioGroupClass: ClassValue = classNames(
		rowDirection ? classes.radioGroupRow : classes.radioGroupColumn,
		{
			[classes.largeGroup]: !isMobileScreen && margin,
			[classes.smallGroup]: isMobileScreen && spaceBetween
		}
	)

	const optionClass: ClassValue = classNames(
		classes[textColor as keyof typeof styles],
		classes[textStyle as keyof typeof styles],
		classes[textWeight as keyof typeof styles]
	)

	return (
		<FormControl component="fieldset" className={classes.formControl}>
			<RadioGroup
				className={radioGroupClass}
				{...input}
			>
				{items.map((item: fieldModel, index: number) =>
					<FormControlLabel
						key={`radio-${input.name}-${index}`}
						classes={{
							label: optionClass
						}}
						value={item.value}
						control={
							<Field
								type="radio"
								name={input.name}
								value={item.value}
								required={true}
								component={FormRadioField}
							/>
						}
						label={item.label}
					/>
				)}
			</RadioGroup>
			{
				touched &&
				((error && <span className={classes.errorStyle}>{error}</span>))
			}
		</FormControl>
	)
}

export default FormRadioGroup
